<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import PlaygroundThinkingBlock from './PlaygroundThinkingBlock.vue';

const props = defineProps({
  toolCallMessages: {
    type: Array,
    required: true,
  },
});

const { t } = useI18n();
const isExpanded = ref(false);
const thinkingCount = computed(() => props.toolCallMessages.length);
</script>

<template>
  <div v-if="toolCallMessages.length > 0" class="flex flex-col gap-2 my-2">
    <button
      class="group flex items-center gap-2 text-xs text-n-slate-10 hover:text-n-slate-12 transition-colors"
      @click="isExpanded = !isExpanded"
    >
      <Icon
        :icon="isExpanded ? 'i-lucide-chevron-down' : 'i-lucide-chevron-right'"
        class="w-3 h-3"
      />
      <span class="flex items-center gap-2">
        {{ t('CAPTAIN.PLAYGROUND.SHOW_STEPS') }}
        <span
          class="inline-flex items-center justify-center h-4 min-w-4 px-1 text-xs rounded bg-n-slate-3 text-n-slate-11"
        >
          {{ thinkingCount }}
        </span>
      </span>
    </button>
    <div v-show="isExpanded" class="space-y-2 pl-5">
      <PlaygroundThinkingBlock
        v-for="(toolCall, index) in toolCallMessages"
        :key="index"
        :content="toolCall.message.content"
      />
    </div>
  </div>
</template>
